import React from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/AuthFetch";
import ExportExamWisePDF from "../../utility/ExportExamWisePdf";
import enableTableSearch from "../../utility/tableSearch";

function ExamWiseReport() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const inputRef = useRef();
  const tableRef = useRef();

  const [loader, setLoader] = useState(false);

  const [standard, setStandard] = useState("");
  const [standardList, setStandardList] = useState([]);
  const [standardSelected, setStandardSelected] = useState(false);
  const [div, setDiv] = useState("");
  const [divList, setDivList] = useState([]);
  const [divSelected, setDivSelected] = useState(false);
  const [type, setType] = useState("");
  const [typeSelected, setTypeSelected] = useState(false);
  const [examName, setExamName] = useState("");
  const [examNameList, setExamNameList] = useState([]);
  const [examNameSelected, setExamNameSelected] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [subjectSelected, setSubjectSelected] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [standardLabel, setStandardLabel] = useState("");
  const [divisionLabel, setDivisionLabel] = useState("");
  const [examNameLabel, setExamNameLabel] = useState("");
  const [finYear, setFinYear] = useState("");
  const [finYearList, setFinYearList] = useState([]);
  const [finYearSelected, setFinYearSelected] = useState(false);

  useEffect(() => {
    const fetchStandard = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/standard-options`
        );
        const result = await response.json();
        setStandardList(result.standard);
      } catch (error) {
        console.error("Error fetching Standard:", error);
      }
    };

    fetchStandard();
  }, []);

  const fetchDiv = async (standard) => {
    setLoader(true);
    setDiv("");
    setDivSelected(false);
    setType("");
    setTypeSelected(false);
    setExamName("");
    setExamNameList([]);
    setExamNameSelected(false);
    setSubjectSelected(false);
    setSubjectList([]);
    if (standard === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/div-options?standard=${standard}`
      );
      const result = await response.json();
      setDivList(result.division);
      setStandardSelected(true);
    } catch (error) {
      console.error("Error fetching division:", error);
      setStandardSelected(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchExamName = async (type) => {
    setLoader(true);
    setExamName("");
    setExamNameList([]);
    setExamNameSelected(false);
    setSubjectSelected(false);
    setSubjectList([]);
    if (type === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/exam-category-options?query=${type}`
      );
      const result = await response.json();
      setExamNameList(result.exam_categories);
      setTypeSelected(true);
    } catch (error) {
      console.error("Error fetching exam name:", error);
      setTypeSelected(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchSubject = async () => {
    setLoader(true);
    setStudentList([]);
    if (standard === "" || div === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/subject-options?standard=${standard}`
      );
      const result = await response.json();
      setSubjectList(result.subjects);
      setExamNameSelected(true);
    } catch (error) {
      console.error("Error fetching subject:", error);
      setExamNameSelected(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchFinYear = async () => {
    setLoader(true);
    setFinYearList([]);
    setFinYear("");
    setFinYearSelected(false);
    setStudentList([]);
    try {
      const response = await authFetch(`${API_BASE_URL}/api/finYear`);
      const result = await response.json();
      setFinYearList(result.finYear);
      setExamNameSelected(true);
    } catch (error) {
      console.error("Error fetching financial year:", error);
      setExamNameSelected(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchStudents = async (finYear) => {
    setLoader(true);
    setStudentList([]);
    if (finYear === "" || finYear === null) return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/exam-wise-report?standard=${standard}&div=${div}&name=${examName}&finYear=${finYear}`
      );
      const result = await response.json();
      setStudentList(result.student);
      setStandardLabel(
        standardList.find((s) => s.id === Number(standard))?.standard || ""
      );

      setDivisionLabel(
        divList.find((d) => d.id === Number(div))?.division || ""
      );
      setExamNameLabel(
        examNameList.find((e) => e.id === Number(examName))?.name || ""
      );
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 0,
      noDataText: "No student found",
    });

    return cleanup;
  }, [loader, studentList]);

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Exam Wise Report</h5>
            <Form ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Class <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="class"
                      required
                      value={standard}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStandard(value);
                        fetchDiv(value);
                      }}
                    >
                      <option value="" disabled>
                        Select Class
                      </option>
                      {standardList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.standard}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {standardSelected && (
                  <>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>
                          Section <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="div"
                          value={div}
                          onChange={(e) => {
                            setDiv(e.target.value);
                            setTypeSelected(false);
                            if (div !== false) setDivSelected(true);
                            else setDivSelected(false);
                          }}
                          required
                        >
                          <option value="" disabled>
                            Select Division
                          </option>
                          {divList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.division}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {divSelected && (
                      <>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="formType">
                            <Form.Label>
                              Exam Type <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="type"
                              value={type}
                              onChange={(e) => {
                                const value = e.target.value;
                                setType(value);
                                fetchExamName(value);
                              }}
                              required
                            >
                              <option value="" disabled>
                                Select Exam Type
                              </option>
                              <option value="Periodic Test">
                                Periodic Test
                              </option>
                              <option value="Internal Assessment">
                                Internal Assessment
                              </option>
                              <option value="Half Yearly">Half Yearly</option>
                              <option value="Annual Exam">Annual Exam</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        {typeSelected && (
                          <>
                            <Col md={4}>
                              <Form.Group className="mb-3" controlId="formType">
                                <Form.Label>
                                  Exam Name
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                  name="name"
                                  value={examName}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setExamName(value);
                                    fetchFinYear();
                                  }}
                                  required
                                >
                                  <option value="" disabled>
                                    Select Exam
                                  </option>
                                  {examNameList?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            {examNameSelected && (
                              <>
                                <Col md={4}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formType"
                                  >
                                    <Form.Label>
                                      Financial Year
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="name"
                                      value={finYear}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setFinYear(value);
                                        fetchSubject();
                                        fetchStudents(value);
                                        setFinYearSelected(true);
                                      }}
                                      required
                                    >
                                      <option value="" disabled>
                                        Select Financial Year
                                      </option>
                                      {finYearList?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.fyName}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>
                                {finYearSelected && (
                                  <>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <ExportExamWisePDF
                                        studentList={studentList}
                                        subjectList={subjectList}
                                        type={type}
                                        examName={examNameLabel}
                                        standardLabel={standardLabel}
                                        divisionLabel={divisionLabel}
                                      />
                                      <Form.Control
                                        type="text"
                                        placeholder="Search"
                                        style={{ width: "200px" }}
                                        ref={inputRef}
                                      />
                                    </div>
                                    <Table
                                      striped
                                      bordered
                                      hover
                                      id="marksTable"
                                      ref={tableRef}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            rowSpan={
                                              type === "Internal Assessment"
                                                ? 2
                                                : 1
                                            }
                                            style={{
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            NAME
                                          </th>
                                          <th
                                            rowSpan={
                                              type === "Internal Assessment"
                                                ? 2
                                                : 1
                                            }
                                            style={{
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            ROLL No.
                                          </th>
                                          <th
                                            rowSpan={
                                              type === "Internal Assessment"
                                                ? 2
                                                : 1
                                            }
                                            style={{
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            ADMISSION No.
                                          </th>
                                          {subjectList?.map((item) => (
                                            <th
                                              colSpan={
                                                type === "Internal Assessment"
                                                  ? 5
                                                  : 1
                                              }
                                              style={{
                                                textAlign: "center",
                                              }}
                                            >
                                              {item.Name}
                                            </th>
                                          ))}
                                        </tr>
                                        {type === "Internal Assessment" && (
                                          <tr>
                                            {subjectList?.map((item) => (
                                              <>
                                                <th>CLASS WORK</th>
                                                <th>HOME WORK</th>
                                                <th>SUB ENRICHMENT</th>
                                                <th>DISCIPLINE</th>
                                                <th>CLASS INVOLVEMENT</th>
                                              </>
                                            ))}
                                          </tr>
                                        )}
                                      </thead>
                                      {studentList.length === 0 ||
                                      subjectList.length === 0 ? (
                                        <tbody>
                                          <tr>
                                            <td colSpan={5}>
                                              Error processing
                                            </td>
                                          </tr>
                                        </tbody>
                                      ) : (
                                        <>
                                          <tbody>
                                            {studentList?.map((item, index) => (
                                              <tr key={index}>
                                                <td>{item.name}</td>
                                                <td>{item.roll}</td>
                                                <td>{item.admission}</td>
                                                {type ===
                                                "Internal Assessment" ? (
                                                  <>
                                                    {item.classWork?.map(
                                                      (mark, i) => (
                                                        <>
                                                          <td>{mark}</td>
                                                          <td>
                                                            {item.homeWork[i]}
                                                          </td>
                                                          <td>
                                                            {
                                                              item
                                                                .subEnrichment[
                                                                i
                                                              ]
                                                            }
                                                          </td>
                                                          <td>
                                                            {item.discipline[i]}
                                                          </td>
                                                          <td>
                                                            {
                                                              item
                                                                .classInvolvement[
                                                                i
                                                              ]
                                                            }
                                                          </td>
                                                        </>
                                                      )
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {item.marks?.map(
                                                      (mark, i) => (
                                                        <td>
                                                          {item.remarks[i] ===
                                                          "AB"
                                                            ? "AB"
                                                            : mark}
                                                        </td>
                                                      )
                                                    )}
                                                  </>
                                                )}
                                              </tr>
                                            ))}
                                          </tbody>
                                        </>
                                      )}
                                    </Table>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExamWiseReport;
